import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {Order} from '../models/order';
import {LoadOrdersSelectedSuccessAction, ordersSelectedActionTypes} from '../actions/orders-selected-load';

export interface OrderSelectedState {
  ordersSelected: Order[];
}

const initialState: OrderSelectedState = {
  ordersSelected: undefined
};

export function OrdersSelectedReducer(state: OrderSelectedState = initialState, action: Action): OrderSelectedState {
  switch (action.type) {
    case ordersSelectedActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case ordersSelectedActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case ordersSelectedActionTypes.CLEAR:
      return handleLoadClearActions();
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: OrderSelectedState, action: LoadOrdersSelectedSuccessAction): OrderSelectedState {
  const newState: OrderSelectedState = {
    ordersSelected: action.payload
  };
  return newState;
}

function handleLoadClearActions(): OrderSelectedState {
  const newState: OrderSelectedState = {
    ordersSelected: []
  };
  return newState;
}

function handleLoadErrorActions(state: OrderSelectedState): OrderSelectedState {
  return state;
}

export const ordersSelectedSelectors = {
  ordersSelected: (state: OrderSelectedState) => _.get(state, 'ordersSelected.array', null)
};
